/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import {
  useBusinessSettings,
  useTemplateDetails,
  useTemplates,
  useTemplatePayUri,
} from "../api/hooks.js";
import { TemplateDetailsScreen } from "../screens/TemplateDetailsScreen.js";
import { Duration } from "@gnu-taler/taler-util";

export function TemplateDetailsRoute({
  templateId,
}: {
  templateId: string;
}): VNode {
  const { template, resource, isLoading } = useTemplateDetails(templateId);
  const { deleteTemplate, createOrderFromTemplate } = useTemplates();
  const { settings } = useBusinessSettings();
  const payUri = useTemplatePayUri()(templateId);

  return (
    <TemplateDetailsScreen
      templateId={templateId}
      template={template}
      templateResource={resource}
      isLoading={isLoading}
      payUri={payUri}
      merchantDefaultPayDeadline={
        settings?.defaultPayDelayUs !== undefined
          ? Duration.formatShort({ d_us: settings.defaultPayDelayUs })
          : undefined
      }
      onDeleteTemplate={deleteTemplate}
      onCreateOrder={(id, body) => createOrderFromTemplate(id, body as never)}
    />
  );
}
